export default {
  'check': () => import('@icons/check-box/check.svg'),
  'check-square-white-default': () =>
    import('@icons/check-box/check-square-white-default.svg'),
  'check-square-white-active': () =>
    import('@icons/check-box/check-square-white-active.svg'),
  'check-square-black-default': () =>
    import('@icons/check-box/check-square-black-default.svg'),
  'check-square-black-active': () =>
    import('@icons/check-box/check-square-black-active.svg'),
  'check-square-focus': () => import('@icons/check-box/check-square-focus.svg'),
  'check-circle-black-default': () =>
    import('@icons/check-box/check-circle-black-default.svg'),
  'check-circle-black-active': () =>
    import('@icons/check-box/check-circle-black-active.svg'),
  'check-circle-white-default': () =>
    import('@icons/check-box/check-circle-white-default.svg'),
  'check-circle-white-active': () =>
    import('@icons/check-box/check-circle-white-active.svg'),
  'popup-check-default': () =>
    import('@icons/check-box/popup-check-default.svg'),
  'popup-check-active': () => import('@icons/check-box/popup-check-active.svg'),
};
